import React from 'react'
import '../../assets/home/header.css'
import { Link } from 'react-router-dom'

function Header() {
  return (
    <div className="container-fluid" id='header'>
          
        <video autoPlay  muted loop src='images/vshoptacbd.MOV' />

        <div className="header">
        <h6>CBD et HHC shop en ligne </h6>
        <p>Découvrez nos produits CBD et HHC au meilleur prix, livré rapidement et gratuitement*</p>
        <button><Link to={'/categories/1'} className='lien'>VOIR NOS BEST SELLER</Link></button>
        </div>
    </div>
  )
}

export default Header